import { Injectable } from "@angular/core";
import { TranslateService } from "ng2-translate";
import { Response } from "@angular/http";
import { Observable } from "rxjs";
/**
 * Error handling for the data client.
 */
export class ErrorService {
    constructor(translate) {
        this.translate = translate;
        this._dataClientErrors = new Observable(observer => {
            this.dataClientErrorsObserver = observer;
        }).share();
        this._errors = new Observable(observer => {
            this.errorsObserver = observer;
        }).share();
    }
    /**
     * Returns an observable sequence of DataClientErrorMessage.
     * @returns {Observable<DataClientErrorMessage>}
     */
    get dataClientErrors() {
        return this._dataClientErrors;
    }
    /**
     * Returns an observable sequence of errors.
     * @returns {Observable<DataClientErrorMessage>}
     */
    get errors() {
        return this._errors;
    }
    reportError(errorMessage) {
        if (this.errorsObserver) {
            this.errorsObserver.next(errorMessage);
        }
    }
    reportDataClientError(errorMessage) {
        if (errorMessage.displayable) {
            this.translate.get(errorMessage.data.messageKey, errorMessage.data.messageParams).subscribe((translation) => {
                errorMessage.message = translation;
                if (this.dataClientErrorsObserver) {
                    this.dataClientErrorsObserver.next(errorMessage);
                }
            });
        }
        else {
            if (this.dataClientErrorsObserver) {
                this.dataClientErrorsObserver.next(errorMessage);
            }
            console.log(errorMessage.status + " - " + errorMessage.message);
        }
    }
}
ErrorService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
ErrorService.ctorParameters = () => [
    { type: TranslateService, },
];
export class DataClientErrorMessage {
    constructor(cause) {
        try {
            this.causeType = cause.constructor.name;
            this.cause = cause;
            if (typeof cause == "string") {
                this.causeType = "string";
                this.message = cause;
            }
            else if (cause instanceof Error) {
                this.message = cause.message;
            }
            else if (cause instanceof Response) {
                let response = cause;
                this.status = response.status;
                if (this.status === 422) {
                    // 422 is a validation error - no logging, and payload is a json object
                    this.validationFailure = true;
                    this.data = response.json();
                }
                else {
                    let json = response.json();
                    if (json.messageKey) {
                        this.displayable = true;
                        this.data = json;
                    }
                    else if (json.conditionName) {
                        this.conditionNotification = true;
                        this.data = json;
                    }
                    if (!this.displayable && !this.conditionNotification) {
                        this.message = response.text();
                    }
                }
            }
            else {
                this.data = cause;
            }
        }
        catch (err) {
            this.data = cause;
        }
    }
}
//# sourceMappingURL=error.service.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fedelta-pos/data-client/error/error.service.js
// module id = 100
// module chunks = 1